import * as React from 'react';
import { Box, Container, Typography } from "@mui/material";
import { useLanguage } from '../../i18n/LanguageContext';

const content = {
    en: {
        title: "About Us",
        phoneAlt: "Smart Key app",
        paragraphs: [
            "TARQIA is a professional services solution provider that offers a wide range of services to businesses of all sizes. As an industry leader, TARQIA is dedicated to delivering high-quality products and services to its clients, with the ultimate goal of helping businesses achieve success.",
            "At TARQIA, the focus is on providing comprehensive solutions that meet the specific needs of each client. Whether its consulting services, project management, software development, or any other professional service, the team at TARQIA has the expertise and experience to deliver exceptional results.",
            "TARQIA is committed to delivering 100% quality products and services. This means that every project undertaken is approached with a rigorous quality assurance process to ensure that the final product meets or exceeds client expectations. The team at TARQIA takes pride in their work and strives to deliver the best possible outcome for their clients.",
            "The ultimate goal of TARQIA is to help businesses achieve success. Whether it’s by developing innovative solutions, improving operational efficiency, or enhancing customer experience, TARQIA is dedicated to helping businesses achieve their objectives. The team at TARQIA understands that every business is unique, and as such, they take a customized approach to each project, tailoring solutions to meet the specific needs of each client.",
            "Overall, TARQIA is an industry-leading professional services solution provider that is committed to delivering high-quality products and services. With a focus on quality, expertise, and customization, TARQIA is dedicated to helping businesses achieve success and reach their ultimate goals.",
        ],
    },
    ar: {
        title: "من نحن",
        phoneAlt: "تطبيق ضياف",
        paragraphs: [
            "ترقية مزوّد حلول للخدمات المهنية يقدم مجموعة واسعة من الخدمات للشركات بمختلف أحجامها. وبصفتها شركة رائدة في مجالها، تلتزم ترقية بتقديم منتجات وخدمات عالية الجودة لعملائها، بهدف أساسي هو مساعدة الشركات على تحقيق النجاح.",
            "تركّز ترقية على تقديم حلول متكاملة تلبي الاحتياجات الخاصة لكل عميل. وسواء تعلق الأمر بالخدمات الاستشارية أو إدارة المشاريع أو تطوير البرمجيات أو أي خدمة مهنية أخرى، يمتلك فريق ترقية الخبرة والتجربة اللازمتين لتحقيق نتائج استثنائية.",
            "تلتزم ترقية بتقديم منتجات وخدمات بجودة 100%، إذ يخضع كل مشروع لعملية صارمة لضمان الجودة حتى يلبي المنتج النهائي توقعات العميل أو يتجاوزها. ويفخر فريق ترقية بعمله ويسعى دائماً لتحقيق أفضل النتائج لعملائه.",
            "الهدف الأسمى لترقية هو مساعدة الشركات على النجاح، سواء من خلال تطوير حلول مبتكرة أو تحسين الكفاءة التشغيلية أو الارتقاء بتجربة العملاء. ويدرك فريق ترقية أن لكل شركة طبيعتها الخاصة، لذا يتبع نهجاً مخصصاً في كل مشروع لتصميم حلول تلبي احتياجات كل عميل.",
            "باختصار، ترقية مزوّد رائد لحلول الخدمات المهنية يلتزم بتقديم منتجات وخدمات عالية الجودة. ومن خلال تركيزها على الجودة والخبرة والتخصيص، تكرّس ترقية جهودها لمساعدة الشركات على النجاح وتحقيق أهدافها.",
        ],
    },
};

const AboutUs = () => {
    const { lang } = useLanguage();
    const c = content[lang];
    return (
        <>
            <Container className="aboutSection" id="aboutusSection">
                <Box className="aboutImg">
                    <img src="/icons/smartkey/about-room.jpg" alt="" />
                    <img src="/icons/smartkey/app-welcome.png" alt={c.phoneAlt} className="aboutPhone" />
                </Box>
                <Box className="aboutContent">
                    <Typography variant="h4" className="aboutHeading">
                        {c.title}
                    </Typography>
                    {c.paragraphs.map((paragraph, index) => (
                        <Typography className="contentParagraph" key={index}>
                            {paragraph}
                        </Typography>
                    ))}
                </Box>
            </Container>
        </>
    )
}
export default AboutUs;
